import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { ProjectDetail } from '@/components/projects/ProjectDetail';

export default function ProjectDetailPage() {
  return (
    <ProtectedRoute>
      <ProjectDetail />
    </ProtectedRoute>
  );
}
